module.exports = __webpack_public_path__ + "img/3_jgyl.933358fa.png";